import { GraduationCap, Brain, Bitcoin, Cpu } from "lucide-react";

const TAGS = [
  { icon: GraduationCap, label: "PhD. v marketingovej komunikácii" },
  { icon: Brain, label: "Strategické a logické myslenie" },
  { icon: Cpu, label: "AI workflow & technológie" },
  { icon: Bitcoin, label: "Crypto / Web3" },
];

export default function About() {
  return (
    <section
      id="o-mne"
      data-testid="about-section"
      className="relative py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <span className="pill-tag" data-testid="about-pill">
              <span className="pill-dot"></span>
              01 — O mne
            </span>
            <h2 className="mt-6 text-4xl lg:text-6xl font-extrabold tracking-tight leading-[1.02]">
              Stratégia, ktorá dobre vyzerá
              <br />
              <span className="text-[#C6F432]">a reálne funguje.</span>
            </h2>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            <p className="text-xl lg:text-2xl text-white/85 leading-relaxed font-light">
              Verím, že marketing vyžaduje viac než len dobrý plán od stola. Ako marketér zastrešujem procesy{" "}
              <span className="text-white font-semibold">end-to-end.</span> —
              od analýzy a strategického plánovania až po kompletnú vizuálnu a technologickú exekúciu. Vďaka tomu dokážem optimalizovať procesy, zrýchliť nasadenie kampaní a šetriť zdroje na externé agentúry.
            </p>
            <p className="mt-6 text-base lg:text-lg text-white/55 leading-relaxed">
              Fascinujú ma technológie, umelá inteligencia a dátová analytika. Bežne zastrešujem prácu celého tímu — strategicky plánujem,
              vizuálne realizujem a meriam dáta, ktoré rozhodujú o ďalšom kroku.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {TAGS.map((t, i) => (
                <div
                  key={t.label}
                  data-testid={`about-tag-${i}`}
                  className="flex items-center gap-3 px-4 py-3.5 rounded-xl border border-white/[0.07] bg-white/[0.02] hover:border-[#C6F432]/40 hover:bg-[#C6F432]/[0.04] transition-colors"
                >
                  <t.icon className="w-5 h-5 text-[#C6F432] shrink-0" />
                  <span className="text-sm text-white/85">{t.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
